import Linkify from 'react-linkify';
import appConstants from '../../../../../appConstants';
import MessageMetaData from './MessageMetaData';
import ChoiceRenderer from '../Header/MCQMessages/ChoiceRenderer';

const ReplyTextMessage = (props) => {
  const { classes, isMessageHistoryFlow } = props;
  return (
    <>
      {props.msg.parentMessage.messageType === appConstants.MESSAGE_TYPE.Dispatcher ? (
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentReceivedScMessageText} ${
            isMessageHistoryFlow ? classes.scMessageHistoryText : ''
          }`}>
          {isMessageHistoryFlow && <div className={classes.driverDispatcherNameReplyLabel}>{props.driverName}</div>}
          <div
            className={`${classes.scMessageContentSentReply} ${
              props.msg.parentMessage.isUrgent ? classes.urgentMessage : ''
            }`}>
            {props.dispatcherName && <span className={classes.driverDispatcherName}>{props.dispatcherName}</span>}
            <Linkify properties={{ target: '_blank' }}>
              {props.msg.parentMessage.message}
              {props.msg.parentMessage.choice?.length > 0 && (
                <ChoiceRenderer choiceData={props.msg.parentMessage.choice} />
              )}
            </Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.parentMessage.messageDateTs)}{' '}
              {props.renderReadIcon(props.msg.parentMessage.isRead, classes)}
            </div>
          </div>
          <div className={classes.messageContainer}>
            <Linkify properties={{ target: '_blank' }}>
              {props.msg.metadata && (
                <MessageMetaData metadata={props.msg.metadata} />
              )}
              {props.msg.message}
            </Linkify>
            <div className={classes.timeStyle}>{props.convertTime(props.msg.messageDateTs)}</div>
          </div>
        </div>
      ) : (
        /* Display dispatcher replied message on message received from driver app */
        <div
          className={`${classes.scMessageText} ${classes.scMessageContentSentScMessagText} ${
            isMessageHistoryFlow ? classes.scMessageHistoryText : ''
          }`}>
          <div className={classes.scMessageContentReceivedReply}>
            {isMessageHistoryFlow && <span className={classes.driverDispatcherName}>{props.driverName}</span>}
            {props.msg.parentMessage.metadata && (
              <MessageMetaData
                metadata={props.msg.parentMessage.metadata}
              />
            )}
            <Linkify properties={{ target: '_blank' }}>{props.msg.parentMessage.message}</Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.parentMessage.messageDateTs)}
            </div>
          </div>
          <div className={classes.messageContainer}>
            {props.dispatcherName && (
              <div className={classes.driverDispatcherNameReplyLabel}>{props.dispatcherName}</div>
            )}
            <Linkify properties={{ target: '_blank' }}>{props.msg.message}</Linkify>
            <div className={classes.timeStyle}>
              {props.convertTime(props.msg.messageDateTs)}{' '}
              {props.renderReadIcon(props.msg.isRead, classes)}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ReplyTextMessage;
